import useStore from '@components/MainStage/store';
import { NodesTypes } from '@constants/canvas/general';
import { useGenerateNodesReportMutation } from '@store/services/reports';
import { canvasMap } from '@utils/canvas/CanvasMap';
import useExportState from '@views/ReportsModel/hooks/useExportState';

const useExportNodes = (projectId: string) => {
  const { isError, setError, fileContent, setFileContent } = useExportState();
  const { getActiveNode } = useStore();

  const [generateNodesReport, { isLoading, reset }] =
    useGenerateNodesReportMutation();

  const handleGenerate = async () => {
    try {
      const ids = canvasMap.nodes.reduce<string[]>(
        (acc, { id, hidden, type }) => {
          if (!hidden && type === NodesTypes.CustomNode) {
            acc.push(id);
          }

          return acc;
        },
        [],
      );

      const excelData = await generateNodesReport({
        projectId,
        ids,
      }).unwrap();

      setFileContent(excelData);
    } catch (e) {
      setError(true);
    }
  };

  const fileName = `Focus On ${getActiveNode()?.data.dto.name} report.xlsx`;

  return {
    isError,
    fileContent,
    isLoading,
    setFileContent,
    setError,
    handleGenerate,
    fileName,
    reset,
  };
};

export default useExportNodes;
